<template>
  <v-dialog :value="dialog" max-width="600" @input="closeDialog">
    <v-card>
      <v-card-title>
        เพิ่มปี
      </v-card-title>
      <v-card-text>
        <FormCreateYear @onClose="closeDialog" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FormCreateYear from "@/components/form/year/FormCreateYear"

export default {
  name: "DialogCreateYear",
  components: {
    FormCreateYear,
  },
  props: {
    dialog: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false)
    },
  },
}
</script>